export * from "./registration-page.component";
export * from "./registration.service";